import React from 'react';
import { gqlLuminateContactModel } from '@minecraft.graphql-types';
import { FlexRow, FlexCol, BodyText } from '@minecraft.atoms';

export const LuminateContactInfo = ({
  label,
  contacts,
  formatPhone,
  wrapped = false,
}: {
  label: string;
  contacts: readonly gqlLuminateContactModel[];
  formatPhone: (phone: string) => string;
  wrapped?: boolean;
}) => {
  return (
    <FlexRow className="cn_mb-2" wrap={wrapped ? 'wrap' : 'nowrap'} gap="2">
      <BodyText fontWeight="bold">{label}:</BodyText>
      <FlexCol>
        {contacts.map((contact) => (
          <div style={{ width: '100%' }} className="cn_mb-2" key={`${contact.email}-${contact.phone}-${contact.name}`}>
            <BodyText title={contact.name} underline>{`${contact.name}`}</BodyText>
            {contact?.phone && (
              <BodyText title={formatPhone(contact.phone)} truncatableNoWrap>
                {formatPhone(contact.phone)}
              </BodyText>
            )}
            {contact?.email && (
              <BodyText title={contact.email} overflowWrap="anywhere">
                {contact.email}
              </BodyText>
            )}
          </div>
        ))}
      </FlexCol>
    </FlexRow>
  );
};
